import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../Hyperlink';

type Props = {
  newNav: boolean;
};

export const NewNavContainer: FC<Props> = ({ newNav, children }) => {
  const source = 'entity-nav';
  if (newNav) {
    return (
      <>
        <div className="page-nav__new-title">
          <FormattedMessage id="components/page-nav/NewNavContainer.tsx/1" />
        </div>
        <div className="page-nav__content">{children}</div>

        <div className="page-nav__footer">
          <Hyperlink href="/a-propos" source={source}>
            <FormattedMessage id="components/page-nav/NewNavContainer.tsx/2" />
          </Hyperlink>
          <Hyperlink href="/aide" source={source}>
            <FormattedMessage id="components/page-nav/NewNavContainer.tsx/3" />
          </Hyperlink>
          <Hyperlink href="/cgu" source={source}>
            <FormattedMessage id="components/page-nav/NewNavContainer.tsx/4" />
          </Hyperlink>
        </div>
      </>
    );
  }
  return <>{children}</>;
};
